import { useState } from "react";
import { api, ApiError, type Pedido } from "../api";

/**
 * A situação de um pedido ao DP, numa linha: aguardando, aprovado ou recusado.
 *
 * O motivo da recusa aparece por inteiro — é o que diz à pessoa o que corrigir
 * antes de mandar de novo. Pedido em aberto pode ser cancelado.
 */
export default function StatusPedido({
  pedido,
  descricao,
  onMudou,
}: {
  pedido: Pedido;
  descricao?: string;
  onMudou: () => void;
}) {
  const [cancelando, setCancelando] = useState(false);
  const [erro, setErro] = useState<string | null>(null);

  async function cancelar() {
    if (!confirm("Cancelar este pedido?")) return;
    setCancelando(true);
    setErro(null);
    try {
      await api.cancelarPedido(pedido.id);
      onMudou();
    } catch (err) {
      setErro(err instanceof ApiError ? err.message : "Não foi possível cancelar.");
    } finally {
      setCancelando(false);
    }
  }

  const classe =
    pedido.status === "Pendente" ? "pedido-aguardando" : pedido.status === "Aprovada" ? "pedido-aprovado" : "pedido-recusado";

  const texto =
    pedido.status === "Pendente"
      ? `Aguardando o DP — enviado em ${pedido.criado_em}`
      : pedido.status === "Aprovada"
        ? `Aprovado pelo DP em ${pedido.decidido_em ?? ""}`
        : `Recusado pelo DP${pedido.motivo ? `: ${pedido.motivo}` : ""}`;

  return (
    <div className={`status-pedido ${classe}`}>
      <div className="status-pedido-texto">
        {descricao && <strong>{descricao}</strong>}
        <span>{texto}</span>
      </div>
      {pedido.status === "Pendente" && (
        <button className="botao-texto" onClick={cancelar} disabled={cancelando}>
          {cancelando ? "Cancelando…" : "Cancelar"}
        </button>
      )}
      {erro && <span className="negativo">{erro}</span>}
    </div>
  );
}
